import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useEditActivityMutation } from "@modules/activities/services/mutations";
import { ActivityFormValues, activitySchema } from "@modules/activities/validations";

export function useEditActivityModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<ActivityFormValues>({
    resolver: zodResolver(activitySchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useEditActivityMutation({
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("activity_admin.success.edit"),
      });

      onComplete?.();
      modalRef.current?.close();
    },
  });

  const handleSubmit = async (data: ActivityFormValues) => {
    const activityId = modalRef.current?.getId();
    await mutateAsync({ id: activityId as string, data });
  }

  return {
    methods,
    isPending,
    handleSubmit,
  };
}
